import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useParams} from "react-router-dom";
import { shopchamAPI } from "../Utility/api";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate , Outlet, NavLink } from 'react-router-dom';
import { signin_customToken } from "../redux/authSlice";

function AutoLoginScreen() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { docId } = useParams();
    const { currentUser } = useSelector((state)=> state.auth);


    useEffect(()=>{
        if(currentUser?.user?.uid === docId){
            navigate('/')
        } else {
            testLogin(docId)
        }
    },[]);

    const testLogin = async (uid) => {
      try {
        const { status, data } = await shopchamAPI.post("/users/scan/", { uid });

        if (status === 200) {
          const { frbUserCustomToken } = data;
          const user = await dispatch(signin_customToken(frbUserCustomToken));
          console.log("User authenticated successfully.");
       
        }
      } catch (error) {
        console.log(error)
        alert("Error during login:", error);
      } finally {
        navigate('/')
      }
    };


  return <div/>
}

export default AutoLoginScreen;